import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  description?: string;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, label, description, id, ...props }, ref) => {
    const inputId = id ?? `switch-${label ?? Math.random().toString(36).slice(2)}`;
    return (
      <label
        htmlFor={inputId}
        className="flex items-center justify-between gap-3 py-2 cursor-pointer select-none"
      >
        <div className="flex-1">
          {label && <div className="text-[13px] font-medium text-[var(--text-primary)]">{label}</div>}
          {description && (
            <div className="text-xs text-[var(--text-secondary)] mt-0.5">{description}</div>
          )}
        </div>
        <input
          ref={ref}
          type="checkbox"
          id={inputId}
          className={cn(
            'appearance-none relative w-10 h-5 rounded-full bg-[var(--bg-hover)] cursor-pointer transition-colors',
            'checked:bg-[var(--accent)]',
            'before:absolute before:top-0.5 before:left-0.5 before:size-4 before:rounded-full before:bg-white before:transition-transform',
            'checked:before:translate-x-5',
            'focus-visible:outline-2 focus-visible:outline-[var(--border-focus)]',
            className,
          )}
          {...props}
        />
      </label>
    );
  },
);
Switch.displayName = 'Switch';
